module.exports = __webpack_public_path__ + "assets/img/player_pause_w.dd567e5d.png";